import React, { useState } from "react";
import { FieldArray, useFormikContext } from "formik";
import {
  FormArrayTextField,
  FormArraySelectField,
  FormDateField,
  FormTextField,
} from "../../../../../partials/content/Forms/FormField";
import { Accordion, AccordionTab } from "primereact/accordion";
import Illustration from "../../../../../partials/content/Illustration";
import { Card } from "react-bootstrap";
import { CustomTextAreaField } from "../../../../../partials/content/Forms";
import { Table } from "react-bootstrap";
import { getSalesActivities } from "../../../../../services/setup/crm/crmSetupService";
import { useEffect } from "react";
import BootstrapTooltip from "../../../../../partials/content/BootstrapTooltip";
import DialogLayout from "../../../../../partials/content/DialogLayout";
import SearchJourney from "../searchJourney";
import { DialogActions } from "@material-ui/core";

function VisitScheduleFormContent(props) {
  const {
    values,
    errors,
    touched,
    setFieldValue,
    handleBlur,
    handleChange,
  } = useFormikContext();
  const [openSearchJourney, setOpenSearchJourney] = useState(false);
  const [salesActivities, setSalesActivities] = useState([]);
  const [activeIndex, setActiveIndex] = useState(0);
  useEffect(() => {
    getSalesActivitiesData();
  }, []);
  return (
    <React.Fragment>
      <Card className="mb-3">
        <Card.Header>
          <i className="fas fa-window-maximize"></i>
          <span>
            <strong>Visit Header</strong>
          </span>
        </Card.Header>
        <Card.Body>
          <div className="row">
            <div className="col-sm-6 col-md-6 col-lg-6">
              <FormTextField
                name="journeyTitle"
                label="Sales Journey Name"
                readonly
                searchButton
                onSearchClick={() => {
                  setOpenSearchJourney(true);
                }}
              />
              <FormDateField name="planVisitDate" label="Plan Visit Date" />
            </div>
            <div className="col-sm-6 col-md-6 col-lg-6">
              <CustomTextAreaField
                label="Description"
                inputType="text"
                propertyName="description"
                onBlur={handleBlur}
                onChange={handleChange}
                values={values}
                touched={touched}
                errors={errors}
                multiline
                minRows={4}
                size="small"
              />
            </div>
          </div>
        </Card.Body>
      </Card>
      <div className="accordion">
        <div className="card">
          <Accordion
            className="accordion"
            activeIndex={activeIndex}
            onTabChange={(e) => setActiveIndex(e.index)}
          >
            <AccordionTab
              header={
                <React.Fragment>
                  <i className="fas fa-sitemap"></i>
                  <span>
                    <strong>Visit Activity Items</strong>
                  </span>
                </React.Fragment>
              }
            >
              <div className="row">
                <div className="col-sm-12 col-md-12 col-lg-12">
                  <FieldArray name="visitActivities">
                    {({ push, remove }) => (
                      <React.Fragment>
                        <div className="row">
                          <div className="col-sm-12 col-md-12 col-lg-12">
                            <div className="card">
                              <Table borderless size="sm" responsive="xl">
                                {values.visitActivities &&
                                values.visitActivities.length > 0 ? (
                                  <thead className="text-center">
                                    <tr>
                                      <th style={{ width: "30%" }}>Activity</th>
                                      <th style={{ width: "25%" }}>Status</th>
                                      <th style={{ width: "40%" }}>Note</th>
                                      <th>Actions</th>
                                    </tr>
                                  </thead>
                                ) : null}
                                <tbody>
                                  {values.visitActivities &&
                                  values.visitActivities.length > 0 ? (
                                    values.visitActivities.map(
                                      (activity, index) => (
                                        <tr key={index}>
                                          <td>
                                            <FormArraySelectField
                                              arrayPropName="visitActivities"
                                              propName="activityID"
                                              index={index}
                                              margin="none"
                                              options={salesActivities}
                                            />
                                          </td>
                                          <td>
                                            <FormArraySelectField
                                              arrayPropName="visitActivities"
                                              propName="statusID"
                                              index={index}
                                              margin="none"
                                              options={[
                                                {
                                                  label: "Unstarted",
                                                  value: 1,
                                                },
                                                { label: "Started", value: 2 },
                                                { label: "Finished", value: 3 },
                                                {
                                                  label: "Cancelled",
                                                  value: 9,
                                                },
                                              ]}
                                            />
                                          </td>
                                          <td>
                                            <FormArrayTextField
                                              arrayPropName="visitActivities"
                                              propName="note"
                                              index={index}
                                              margin="none"
                                            />
                                          </td>
                                          <td
                                            style={{ whiteSpace: "nowrap" }}
                                            className="text-center"
                                          >
                                            <BootstrapTooltip title="Delete Activity Item">
                                              <button
                                                type="button"
                                                className={`btn btn-icon btn-label-danger btn-md btn-circle mx-1`}
                                                onClick={() => {
                                                  remove(index);
                                                }}
                                              >
                                                <i className="fas fa-trash-alt"></i>
                                              </button>
                                            </BootstrapTooltip>
                                          </td>
                                        </tr>
                                      )
                                    )
                                  ) : (
                                    <tr>
                                      <td
                                        className="text-center py-3"
                                        colSpan="4"
                                      >
                                        <Illustration
                                          imageSource="INVIFO CRM.png"
                                          guidance="You don't have any Visit Activity items yet"
                                          guidanceLeftIcon="fas fa-info-circle kt-font-warning"
                                          size="sm"
                                        ></Illustration>
                                      </td>
                                    </tr>
                                  )}
                                  <tr>
                                    <td
                                      className="text-center py-3"
                                      colSpan="4"
                                    >
                                      <button
                                        type="button"
                                        className="btn btn-label-primary btn-md btn-pill btn-bold mx-1"
                                        onClick={() => {
                                          push({
                                            ID: 0,
                                            visitID: 0,
                                            activityID: 0,
                                            statusID: 0,
                                            userID: 0,
                                            userName: "",
                                            note: "",
                                            dsSetup: false,
                                            tasks: [],
                                            directSales: {},
                                            deleteInd: false,
                                          });
                                        }}
                                      >
                                        <i className="fas fa-plus-circle"></i>
                                        Add Activity
                                      </button>
                                    </td>
                                  </tr>
                                </tbody>
                              </Table>
                            </div>
                          </div>
                        </div>
                      </React.Fragment>
                    )}
                  </FieldArray>
                </div>
              </div>
            </AccordionTab>
          </Accordion>
        </div>
      </div>
      <DialogLayout
        open={openSearchJourney}
        title="Search Sales Journey"
        maxWIdth="md"
        onCloseDialog={() => {
          setOpenSearchJourney(false);
        }}
      >
        <SearchJourney
          onSelectJourney={(journey) => {
            setFieldValue("journeyID", journey.ID);
            setFieldValue("journeyTitle", journey.ID + " - " + journey.title);
            setOpenSearchJourney(false);
          }}
        />
        <DialogActions>
          <button
            type="button"
            className="btn btn-label-danger btn-md btn-pill btn-bold"
            onClick={() => {
              setOpenSearchJourney(false);
            }}
          >
            <i className="fas fa-window-close"></i>
            Close
          </button>
        </DialogActions>
      </DialogLayout>
    </React.Fragment>
  );

  async function getSalesActivitiesData() {
    const salesActivitiesTmp = [];
    const response = await getSalesActivities();
    const { data } = response.data;
    const { salesActivities } = data;
    salesActivities.forEach((item) => {
      salesActivitiesTmp.push({
        label: item.salesActivityName,
        value: item.ID,
      });
    });

    setSalesActivities(salesActivitiesTmp);
  }
}

export default VisitScheduleFormContent;
